import * as React from 'react';

import * as Schema from 'nutshell-core/schema';
import type {EntityListType} from 'nutshell-core/types';

import {Modal} from 'shells/modal/modal';

import {ColumnPickerContainer} from './column-picker-container';
import './column-picker-modal.module.css';

type ColumnPickerModalProps = {
    entityType: EntityListType;
    isOpen: boolean;
    schemaProperties: Schema.FieldProperties[];
    onResetFieldsToDefault: () => any;
    onUpdateFields: (arg1: string[]) => any;
    selectedColumns: string[];
    onClose: () => any;
};

export class ColumnPickerModal extends React.PureComponent<ColumnPickerModalProps> {
    columnPicker: any;

    render() {
        return (
            <Modal
                isOpen={this.props.isOpen}
                headerText='Select your columns'
                onClose={this.props.onClose}
                onBeforeClose={this.updateFields}
            >
                <ColumnPickerContainer
                    ref={(node) => {
                        this.columnPicker = node;
                    }}
                    entityType={this.props.entityType}
                    onResetFieldsToDefault={this.props.onResetFieldsToDefault}
                    schema={this.props.schemaProperties}
                    selectedColumns={this.props.selectedColumns}
                />
            </Modal>
        );
    }

    updateFields = () => {
        if (this.columnPicker) {
            this.props.onUpdateFields(this.columnPicker.getSelectedColumns());
        }
    };
}
